import React from "react";
import { Avatar, Badge } from "antd";

const UserCell = ({ chat, selectedSectionId, onSelectUser }) => {

  const formatMessageTime = (timestamp) => {
    const options = { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric', 
      hour: '2-digit', 
      minute: '2-digit' 
    };
    return new Date(timestamp).toLocaleString('en-US', options);
  };

  return (
    <div
      className={`gx-chat-user-item ${chat.source === "whatsapp" ? "whatsapp" : "internal"} ${
        selectedSectionId === chat.id ? "active" : ""
      }`}
      onClick={() => {
        onSelectUser(chat);
      }}
    >
      <div className="gx-chat-user-row">
        <div className="gx-chat-avatar">
          <div className="gx-status-pos">
            <Avatar
              src={chat.avatar || require("assets/images/avatar/user.jpg")}
              className="gx-size-40"
              alt={chat.receiver_name}
            />
            <span className={`gx-status gx-small gx-${chat.status}`} />
          </div>
        </div>

        <div className="gx-chat-info">
          <span className="gx-name h4" style={{ fontSize: "18px" }}>
            {chat.receiver_name}
          </span>
          <div
            className="gx-chat-info-des gx-text-truncate"
            style={{ fontSize: "12px" }}
          >
            {typeof chat.last_message === "string"
              ? chat.last_message.substring(0, 25) + "..."
              : ""}
          </div>
          <div className="gx-last-message-time" style={{ fontSize: "10px" }}>
            {chat?.last_message_time ? formatMessageTime(chat.last_message_time) : "Time not available"}
          </div>
        </div>

        {chat.unread_message_count > 0 && (
          <div className="gx-chat-date">
            <Badge
              count={chat.unread_message_count}
              className="gx-unread-badge"
              style={{
                backgroundColor: "#52c41a",
                fontSize: "12px",
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

const ChatUserList = ({chatUsers, selectedSectionId, onSelectUser}) => {

  return (
    <div className="gx-chat-user">
      {chatUsers.map((chat, chIdx) => (
        <UserCell
          key={chIdx}
          chat={chat}
          selectedSectionId={selectedSectionId}
          onSelectUser={onSelectUser}
        />
      ))}
    </div>
  )
};

export default ChatUserList;